export const MAX_WAITING_FOR_VENDOR_DELIVERY_METHOD_IN_DAYS = 7;
